import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'jquery/dist/jquery.min.js';
import AppRouter from './Router/Router';
function App() {
  return (
    <div id="App">
      <AppRouter />
    </div>
  );
}

export default App;

